import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ErrorRouteBoundary } from "@/src/common/components/error-route-boundary";
import { TENANT_ROUTES } from "@/src/tenant/constants/tenant-routes";
import { TenantRouteLayout } from "@/src/tenant/layouts/tenant-route-layout";

const TenantBookingContractPage = lazy(() => import("@/src/tenant/pages/tenant-booking-contract-page"));
const TenantBookingDetailPage = lazy(() => import("@/src/tenant/pages/tenant-booking-detail-page"));
const TenantBookingsPage = lazy(() => import("@/src/tenant/pages/tenant-bookings-page"));
const TenantCautionDetailPage = lazy(() => import("@/src/tenant/pages/tenant-caution-detail-page"));
const TenantCautionsPage = lazy(() => import("@/src/tenant/pages/tenant-cautions-page"));
const TenantProfilePage = lazy(() => import("@/src/tenant/pages/tenant-profile-page"));

export const tenantRoutes: RouteObject = {
	element: <TenantRouteLayout />,
	errorElement: <ErrorRouteBoundary />,
	children: [
		{ path: TENANT_ROUTES.BOOKINGS, element: <TenantBookingsPage /> },
		{ path: TENANT_ROUTES.BOOKING_DETAIL, element: <TenantBookingDetailPage /> },
		{ path: TENANT_ROUTES.BOOKING_CONTRACT, element: <TenantBookingContractPage /> },
		{ path: TENANT_ROUTES.CAUTIONS, element: <TenantCautionsPage /> },
		{ path: TENANT_ROUTES.CAUTION_DETAIL, element: <TenantCautionDetailPage /> },
		{ path: TENANT_ROUTES.PROFILE, element: <TenantProfilePage /> },
	],
};
